import React, {useState, useEffect, useLayoutEffect} from 'react';
import ReactDOM from 'react-dom/client';
import { useNavigate } from 'react-router-dom';
import './index.css';
//import App from './App';
import reportWebVitals from './reportWebVitals';

import './App.css';
import './output.css';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from 'react-router-dom';

import Home from './Home';
import User from './User';
import About from './About';
import Rank from './Rank';
import Blank from './Blank';
import Pay from './Pay';
import Tip from './Tip';

function AllPage(){
  let navigate = useNavigate();

  const currentURL = window.location.href;

  var temp_type = 0

  if (currentURL.includes("user")){
    temp_type = 1
  }
  else if (currentURL.includes("rank")){
    temp_type = 2
  }
  else if (currentURL.includes("about")){
    temp_type = 3
  }
  else{
    temp_type = 0
  }

  const [type, setType] = useState(temp_type);
  const [changeClass, setChangeClass] = useState(false);

  /*
  function change_to_type0(){
    setType(0)
  }

  function change_to_type1(){
    setType(1)
  }

  function change_to_type2(){
    setType(2)
  }
  */

  function navigate_to_page0(){
    setType(0)
    navigate('/')

    setChangeClass(false)
    setTimeout(() => {
      setChangeClass(true)
    }, 100);    
  }

  function navigate_to_page1(){
    setType(1)    
    navigate('/user')

    setChangeClass(false)
    setTimeout(() => {
      setChangeClass(true)
    }, 100);        
  }

  function navigate_to_page2(){
    setType(2)    
    navigate('/rank')

    setChangeClass(false)
    setTimeout(() => {
      setChangeClass(true)
    }, 100);        
  }

  function navigate_to_page3(){
    setType(3)    
    navigate('/about')

    setChangeClass(false)
    setTimeout(() => {
      setChangeClass(true)
    }, 100);        
  }

  // jsx注释 ctrl+/

  setTimeout(() => {
    setChangeClass(true)
  }, 100);

  if (type === 0){
    return(
      <div style={{minWidth:'76rem'}} className='bg-amber-50'>
        <div className='flex'>
          <div style={{position:'relative'}} className= "z-20 w-16 h-16 grid text-center place-content-center bg-amber-50">
            <div style={{position:'relative', top:'0.25rem'}} className='font2'>
              首页
              {/* <Link onClick={change_to_type0} to="/">Home</Link> */}
            </div>
            <div style={{position:'relative', height:'0.5rem', top:'1rem', transition:'opacity 1s ease'}} className= { !changeClass ? 'w-16 bg-amber-200 opacity-0' : 'w-16 bg-amber-200 opacity-100'}>
            </div>
          </div>  
          <div onClick={navigate_to_page1} style={{cursor:"pointer"}} className="z-20 ml-2 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              用户
              {/* <Link onClick={change_to_type1} to="/page1">Page1</Link> */}
            </div>
          </div>  
          <div onClick={navigate_to_page2} style={{cursor:"pointer"}} className="z-20 ml-2 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              排行榜
              {/* <Link onClick={change_to_type1} to="/page1">Page1</Link> */}
            </div>
          </div>                           
          <div onClick={navigate_to_page3} style={{cursor:"pointer"}} className="z-20 ml-2 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              关于
              {/* <Link onClick={change_to_type2} to="/page2">Page2</Link> */}
            </div>
          </div>
        </div> 
      </div>
    )
  }

  if (type === 1){
    return(
      <div style={{minWidth:'80rem'}} className='bg-amber-50'>
        <div className='flex'>
          <div onClick={navigate_to_page0} style={{cursor:"pointer"}} className="z-20 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              首页
              {/* <Link onClick={change_to_type0} to="/">Home</Link> */}
            </div>
          </div>  
          <div className="z-20 ml-2 w-16 h-16 grid text-center place-content-center bg-amber-50">
            <div style={{position:'relative', top:'0.25rem'}} className='font2'>
              用户
              {/* <Link onClick={change_to_type1} to="/page1">Page1</Link> */}
            </div>
            <div style={{position:'relative', height:'0.5rem', top:'1rem', transition:'opacity 1s ease'}} className= { !changeClass ? 'w-16 bg-amber-200 opacity-0' : 'w-16 bg-amber-200 opacity-100'}>
            </div>
          </div>   
          <div onClick={navigate_to_page2} style={{cursor:"pointer"}} className="z-20 ml-2 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              排行榜
              {/* <Link onClick={change_to_type2} to="/page2">Page2</Link> */}
            </div>
          </div>                         
          <div onClick={navigate_to_page3} style={{cursor:"pointer"}} className="z-20 ml-2 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              关于
              {/* <Link onClick={change_to_type2} to="/page2">Page2</Link> */}
            </div>
          </div>
        </div> 
      </div>
    )
  }  

  if (type === 2){
    return(
      <div style={{minWidth:'70rem'}} className='bg-amber-50'>
        <div className='flex'>
          <div onClick={navigate_to_page0} style={{cursor:"pointer"}} className="z-20 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              首页
              {/* <Link onClick={change_to_type0} to="/">Home</Link> */}
            </div>
          </div>  
          <div onClick={navigate_to_page1} style={{cursor:"pointer"}} className="z-20 ml-2 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              用户
              {/* <Link onClick={change_to_type1} to="page1">Page1</Link> */}
            </div>
          </div>   
          <div className="z-20 ml-2 w-16 h-16 grid text-center place-content-center bg-amber-50">
            <div style={{position:'relative', top:'0.25rem'}} className='font2'>
              排行榜
              {/* <Link onClick={change_to_type1} to="/page1">Page1</Link> */}
            </div>
            <div style={{position:'relative', height:'0.5rem', top:'1rem', transition:'opacity 1s ease'}} className= { !changeClass ? 'w-16 bg-amber-200 opacity-0' : 'w-16 bg-amber-200 opacity-100'}>
            </div>
          </div>                           
          <div onClick={navigate_to_page3} style={{cursor:"pointer"}} className="z-20 ml-2 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              关于
              {/* <Link onClick={change_to_type2} to="/page2">Page2</Link> */}
            </div>
          </div>
        </div> 
      </div>
    )
  } 

  if (type === 3){
    return(
      <div style={{minWidth:'60rem'}} className='bg-amber-50'>
        <div className='flex'>
          <div onClick={navigate_to_page0} style={{cursor:"pointer"}} className="z-20 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              首页
              {/* <Link onClick={change_to_type0} to="/">Home</Link> */}
            </div>
          </div>  
          <div onClick={navigate_to_page1} style={{cursor:"pointer"}} className="z-20 ml-2 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              用户
              {/* <Link onClick={change_to_type1} to="page1">Page1</Link> */}
            </div>
          </div>   
          <div onClick={navigate_to_page2} style={{cursor:"pointer"}} className="z-20 ml-2 w-16 h-16 grid place-content-center bg-amber-50">
            <div className='font2'>
              排行榜
              {/* <Link onClick={change_to_type1} to="page1">Page1</Link> */}
            </div>
          </div>                           
          <div className="z-20 ml-2 w-16 h-16 grid text-center place-content-center bg-amber-50">
            <div style={{position:'relative', top:'0.25rem'}} className='font2'>
              关于
              {/* <Link onClick={change_to_type2} to="/page2">Page2</Link> */}
            </div>
            <div style={{position:'relative', height:'0.5rem', top:'1rem', transition:'opacity 1s ease'}} className= { !changeClass ? 'w-16 bg-amber-200 opacity-0' : 'w-16 bg-amber-200 opacity-100'}>
            </div>
          </div>
        </div> 
      </div>
    )
  }    
}

const App = () => {
  return(
    <Router>
      <div>
        <div>
            <nav>
              <AllPage>
              </AllPage>
            </nav>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/user" element={<User />} />
              <Route path="/rank" element={<Rank />} />
              <Route path="/about" element={<About />} />
              <Route path="/blank" element={<Blank />} />      
              <Route path="/pay" element={<Pay />} />   
              <Route path="/tip" element={<Tip />} />        
            </Routes>
        </div> 
      </div>
    </Router>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
